/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Dry_Run_HintInputs */

const cs_sreality_dry_run_hint = /** @type {(inputs: Sreality_Dry_Run_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uloží nastavení bez přihlášení. Po úspěšném Testu vypněte.`)
};

const en_sreality_dry_run_hint = /** @type {(inputs: Sreality_Dry_Run_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves settings without logging in. Turn off after Test succeeds.`)
};

/**
* | output |
* | --- |
* | "Saves settings without logging in. Turn off after Test succeeds." |
*
* @param {Sreality_Dry_Run_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_dry_run_hint = /** @type {((inputs?: Sreality_Dry_Run_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Dry_Run_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_dry_run_hint(inputs)
	return cs_sreality_dry_run_hint(inputs)
});